module.exports = __webpack_public_path__ + "img/metaPayEnable.1768784e.svg";